import { MotionValue } from 'motion/react';

import { Distance, GridPosition, Position, PositionDelta, Size, Span } from './types';

export function getPositionChange(moved: Position, threshold: Size): PositionDelta {
    let columnDelta = 0;
    let rowDelta = 0;
    if (moved.x > threshold.x) {
        columnDelta = 1;
    } else if (moved.x < -threshold.x) {
        columnDelta = -1;
    }
    if (moved.y > threshold.y) {
        rowDelta = 1;
    } else if (moved.y < -threshold.y) {
        rowDelta = -1;
    }
    return { x: columnDelta, y: rowDelta };
}

export function getMovement(dragOffsetX: MotionValue<number>, dragOffsetY: MotionValue<number>): Distance {
    const movedPixels: Position = { x: dragOffsetX.get(), y: dragOffsetY.get() };
    const absMovedPixels: Position = { x: Math.abs(movedPixels.x), y: Math.abs(movedPixels.y) };
    return { ...movedPixels, abs: absMovedPixels };
}

export function getNextIndex(currentPosition: Position, change: PositionDelta, span: Span): number {
    // if the columns or rows span 2 instead of one, they must start at left/top position.
    const column = span.x !== 2 ? Math.max(0, Math.min(1, currentPosition.x + change.x)) : 0;
    const row = span.y !== 2 ? Math.max(0, Math.min(1, currentPosition.y + change.y)) : 0;
    const nextIndex = row * 2 + column;
    return nextIndex;
}

export function getOccupiedIndexes(position: GridPosition): number[] {
    const startRow = Math.floor(position.index / 2);
    const startColumn = position.index % 2;
    const occupiedIndexes: number[] = [];
    occupiedIndexes.push(position.index);

    if (position.x === 2 && startColumn === 0) {
        occupiedIndexes.push(position.index + 1);
    }
    if (position.y === 2 && startRow === 0) {
        occupiedIndexes.push(position.index + 2);
    }
    if (position.x === 2 && position.y === 2 && startRow === 0 && startColumn === 0) {
        occupiedIndexes.push(position.index + 3);
    }

    return occupiedIndexes;
}
